module.exports = "<div> {{ address.unit ? address.unit+'/' : '' }}{{ address.street_number }} {{ address.street }} </div> <div> {{ address.suburb }} {{ address.state }} </div> <div> {{ address.postcode }} </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/address/address-display.component.html
// module id = ./src/app/shared/components/address/address-display.component.html
// module chunks = 21